import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ROLLEN_LABELS = {
  turnierleitung: '🏆 Turnierleitung',
  anmeldung: '📋 Anmeldung',
  ombudsmann: '🤝 Ombudsmann',
  hauptkampfrichter: '👨‍⚖️ Hauptkampfrichter',
  seitenkampfrichter: '⚖️ Seitenkampfrichter',
  punktrichter: '📝 Punktrichter',
  zeitnehmer: '⏱️ Zeitnehmer',
  mattenleiter: '🎯 Mattenleiter',
  schreiber: '✍️ Schreiber',
  helfer: '🙌 Helfer',
  arzt: '👨‍⚕️ Arzt',
  sanitaeter: '🚑 Sanitäter',
};

function decodeToken(token) {
  try { return JSON.parse(atob(token.split('.')[1])); } catch { return null; }
}

export default function StaffDashboard() {
  const navigate = useNavigate();
  const [staffInfo, setStaffInfo] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { navigate('/anmelden'); return; }
    const payload = decodeToken(token);
    if (!payload || payload.role !== 'personal') { navigate('/anmelden'); return; }
    setStaffInfo(payload);
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('staffData');
    navigate('/anmelden');
  };

  if (!staffInfo) return null;

  const rollLabel = ROLLEN_LABELS[staffInfo.primaer_rolle] || staffInfo.primaer_rolle;

  return (
    <div style={s.page}>
      <div style={s.card}>
        <div style={s.header}>
          <span style={s.icon}>👥</span>
          <div>
            <div style={s.name}>{staffInfo.name}</div>
            <div style={s.rolle}>{rollLabel}</div>
          </div>
        </div>

        <div style={s.infoBox}>
          <div style={s.infoRow}>
            <span style={s.infoLabel}>Benutzername</span>
            <span style={s.infoVal}>{staffInfo.username}</span>
          </div>
          <div style={s.infoRow}>
            <span style={s.infoLabel}>Rolle</span>
            <span style={s.infoVal}>{rollLabel}</span>
          </div>
        </div>

        <div style={s.statusBox}>
          <span style={s.statusDot} />
          Eingeloggt — guten Einsatz!
        </div>

        <button style={s.logoutBtn} onClick={handleLogout}>
          Abmelden
        </button>
      </div>
    </div>
  );
}

const s = {
  page: {
    minHeight: '100vh',
    background: '#0d0d0d',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.5rem',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  },
  card: {
    width: '100%',
    maxWidth: 420,
    background: '#161616',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 14,
    padding: '2rem',
    boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
  },
  icon: { fontSize: '2.5rem', lineHeight: 1 },
  name: { fontSize: '1.3rem', fontWeight: 700, color: '#fff' },
  rolle: { fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)', marginTop: '0.2rem' },
  infoBox: {
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 10,
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.6rem',
  },
  infoRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  infoLabel: { fontSize: '0.8rem', color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: '0.04em' },
  infoVal: { fontSize: '0.9rem', color: '#fff', fontWeight: 500 },
  statusBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: '#22c55e',
    fontSize: '0.9rem',
    fontWeight: 500,
  },
  statusDot: {
    width: 8, height: 8,
    borderRadius: '50%',
    background: '#22c55e',
    boxShadow: '0 0 6px #22c55e',
    flexShrink: 0,
  },
  logoutBtn: {
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8,
    color: 'rgba(255,255,255,0.5)',
    padding: '0.6rem',
    cursor: 'pointer',
    fontSize: '0.85rem',
  },
};
